import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage, injectIntl } from 'react-intl'

import { Text, Stack, Box, Flex, Image, Center } from '@chakra-ui/react'

import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'
import { getTag } from '../helper'
import styles from '../styles.module.less'
import intlMessages from '../translations'

import pinkslipImage from 'src/images/pinkslip.svg'
import eidCardImage from 'src/images/eid-card.svg'
import { getStaticUrl, handleKeyDown } from 'src/utils/helpers'

const staticUrl = getStaticUrl()

const SlipCard = ({ intl, record, onSelected, onAddToWallet, isWalletButtonVisible, language }) => {
  const handleClick = e => {
    e.preventDefault()

    if (typeof onSelected === 'function') {
      onSelected(record)
    }
  }

  const isEIDCard = record.hasOwnProperty('isEIDCard') && record.isEIDCard === true

  const classNamesCard = cx({
    [styles.card]: true,
    [styles.slipCard]: true,
    [styles.pinkSlipCard]: !isEIDCard,
    [styles.vehicleIdCard]: isEIDCard,
  })

  const pinkSlipCardImage = !isEIDCard ? pinkslipImage : eidCardImage

  return (
    <Stack className={styles.cardLayout}>
      <Stack
        onClick={handleClick}
        className={classNamesCard}
        tabIndex='0'
        onKeyDown={handleKeyDown(handleClick)}
      >
        <Flex align={'center'}>
          <Flex
            className={styles.topLeft}
            direction={'row'}
            justify={'space-between'}
            align={'center'}
          >
            <Image w={'68px'} src={staticUrl + pinkSlipCardImage} alt='pinkslip' />
            {record.hasOwnProperty('tag') && record.tag && (
              <Box className={`${styles.tags} ${styles[record.tag]}`}>
                {getTag(record.tag, intl)}
              </Box>
            )}
          </Flex>
        </Flex>
        <Flex direction={'column'} justify={'center'} align={'center'}>
          <Text
            variant='epink'
            opacity={0.6}
            align={'center'}
            fontSize={'16px'}
            textTransform={'uppercase'}
          >
            {record.label}
          </Text>
          <Text variant='epink' mt={'15px'} opacity={0.5} fontSize={'14px'}>
            {intl.formatMessage(intlMessages.policyInsurer)}
          </Text>
          <Text
            variant='epink'
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={'18px'}
            textTransform={'uppercase'}
          >
            {record.insurer}
          </Text>
        </Flex>

        <Flex
          gap={language === 'fr' ? '10px' : '0'}
          direction={language === 'fr' ? 'column' : 'row'}
          align={'center'}
          justify={'space-between'}
          wrap={'wrap'}
          className={styles.dates}
        >
          <Flex
            direction={'column'}
            justify={'center'}
            align={'center'}
            className={styles.date + ' ' + styles.dateEffective}
          >
            <Flex direction={'row'} align={'center'} opacity={0.5}>
              <Flex>
                <FontAwesomeIconComponent icon={['far', 'calendar-check']} size='xs' type='black' />
              </Flex>
              <Text variant='epink' mx={'5px'} fontSize={'14px'}>
                {intl.formatMessage(intlMessages.policyDateEffective)}
              </Text>
            </Flex>
            <Center>
              <Text
                variant='epink'
                align={'center'}
                fontWeight={'bold'}
                opacity={0.6}
                textTransform={'uppercase'}
                fontSize={'14px'}
              >
                {record.dateEffective || 'AUG 03.2023'}
              </Text>
            </Center>
          </Flex>
          <Flex
            direction={'column'}
            justify={'center'}
            align={'center'}
            className={styles.date + ' ' + styles.dateExpiry}
          >
            <Flex direction={'row'} align={'center'} opacity={0.5}>
              <Flex>
                <FontAwesomeIconComponent icon={['far', 'calendar-xmark']} size='xs' type='black' />
              </Flex>
              <Text variant='epink' mx={'5px'} fontSize={'14px'}>
                {intl.formatMessage(intlMessages.policyDateExpiry)}
              </Text>
            </Flex>
            <Center>
              <Text
                variant='epink'
                align={'center'}
                fontWeight={'bold'}
                opacity={0.6}
                textTransform={'uppercase'}
                fontSize={'14px'}
              >
                {record.dateExpiry || 'AUG 03.2023'}
              </Text>
            </Center>
          </Flex>
        </Flex>
        <Flex justify={'center'}>
          <Center mt={'20px'}>
            {!isWalletButtonVisible ? (
              <Flex direction={'row'} align={'center'} opacity={0.6}>
                <FontAwesomeIconComponent icon={['far', 'check']} size='xs' type='black' />
                <Text fontSize={'14px'} ml={'5px'} variant='epink'>
                  Added to wallet
                </Text>
              </Flex>
            ) : (
              <Flex
                direction={'row'}
                align={'center'}
                className={styles.cardButton}
                onClick={e => onAddToWallet(e, record)}
              >
                <FontAwesomeIconComponent icon={['far', 'wallet']} size='xs' type='black' />
                <Text ml={'10px'} variant='epink'>
                  <FormattedMessage
                    id='app.document.link.addToWallet'
                    defaultMessage='Add to wallet'
                  />
                </Text>
              </Flex>
            )}
          </Center>
        </Flex>
      </Stack>
    </Stack>
  )
}

SlipCard.propTypes = {
  record: PropTypes.object.isRequired,
}

export default injectIntl(SlipCard)
